import { render, staticRenderFns } from "./TMenuOptionsGroup.vue?vue&type=template&id=3fca9866&scoped=true&"
import script from "./TMenuOptionsGroup.vue?vue&type=script&lang=js&"
export * from "./TMenuOptionsGroup.vue?vue&type=script&lang=js&"
import style0 from "./TMenuOptionsGroup.vue?vue&type=style&index=0&id=3fca9866&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fca9866",
  null
  
)

export default component.exports